export interface Button {
    text: string;
    type: string;
    gotoStep: string;
    value: boolean;
    redColor: boolean;
    answered: boolean;
    clickSound?: boolean;
    width?: string;
    canDisabled?: boolean;
    startInvisible?: boolean;
    patient?: string;
    page?: number;
    greenColor?: boolean;
    veryRedColor?: boolean;
}

export interface WelcomeStep {
    name: string;
    text: string;
    positionTop: boolean;
    textIsMaxSize: boolean;
    bitTitle: boolean;
    buttons: Button[];
    background: string;
}

export interface LearnStep {
    name: string;
    text: string;
    positionTop: boolean;
    topFull: boolean;
    draggable: boolean;
    transform: string;
    left: string;
    height: string;
    buttons: Button[];
}
export interface TeachBlockPage {
    image: string;
    scroll: boolean;
}
export interface TeachBlock {
    closeClick: string;
    pages: TeachBlockPage[];
}
export interface PatientCard {
    analyzesStep: string;
    closeClick: string;
    pages: string[];
}
export interface PatientAnalyzes {
    toCardClick: string;
    nextClick: string;
    windowType: number;
    windowStartPage?: number;
    analyzes: string[][];
    analyzesHeights: number[][];
}

export interface QuestionItem {
    name: string;
    correct: boolean;
    selected?: boolean;
}
export interface QuestionBlock {
    title: string;
    result: string;
    nextStep: string;
    nextStepCorrect: string;
    answers: QuestionItem[];
}



export interface CabinetStep {
    patient: string;
    branch: number;
    name: string;
    text: string;
    bitTitle: boolean;
    textIsMaxSize: boolean;
    isEnter: boolean;
    hasPatient: boolean;
    speak: boolean;
    textHeight: string;
    positionTop: boolean;
    draggable: boolean;
    aspectRatio: boolean;
    gematogen: boolean;
    isPrize: boolean;
    isPrizeShow: boolean;
    prize: number;
    prizes: string[];
    pcClick: string;
    cardClick: string;
    closeClick: string;
    transform: string;
    transition: string;
    left: string;
    top: string;
    height: string;
    singlePCWindow: string;
    stepSound: string;
    background: string;
    rating: number;
    question: QuestionBlock;
    buttons: Button[];
    patientCard: PatientCard;
    patientAnalyzes: PatientAnalyzes;
    teachBlock: TeachBlock;
}
export const emtyDay = {
    patient: '',
    branch: 0,
    name: '',
    text: '',
    bitTitle: false,
    textIsMaxSize: false,
    isEnter: false,
    textHeight: 'auto',
    positionTop: true,
    hasPatient: false,
    speak: false,
    draggable: false,
    aspectRatio: false,
    gematogen: false,
    isPrize: false,
    isPrizeShow: false,
    prize: 0,
    prizes: [],
    pcClick: '',
    cardClick: '',
    closeClick: '',
    transform: '',
    transition: '',
    left: '',
    top: '',
    height: '',
    singlePCWindow: '',
    stepSound: '',
    background: '',
    rating: 0,
    buttons: [],
    question: {
        title: "",
        result: "",
        nextStep: "",
        nextStepCorrect: "",
        answers: []
    },
    patientCard: {
        analyzesStep: "",
        closeClick: "",
        pages: []
    },
    patientAnalyzes: {
        toCardClick: "",
        nextClick: "",
        windowType: 0,
        windowStartPage: 0,
        analyzes: [],
        analyzesHeights: []
    },
    teachBlock: {
        closeClick: "",
        pages: []
    }
}


export interface PCButton {
    text: string;
    type: string;
    value: boolean;
    color: string;
    shadowColor: string;
}


export interface UserData {
    userid: string;
    step: string;
    type: string;
    branch: string;
    stepname:string;
    accountid: string;
    patient: string;
}


